
/**
 * 托兒所一欄表
 */
export const getCrecheListBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '社會工作局' },
  { title: '托兒所一覽表' },
];

/**
 * 收費一欄表
 */
export const getChargeListBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '社會工作局' },
  { title: '托兒所收費表' },
];

/**
 * 招收幼兒日程
 */
export const getWebRecruitScheduleBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '社會工作局' },
  { title: '2025年受資助托兒所招收幼兒日程' },
];

/**
 * 招收幼兒日程
 */
export const getWebFosterBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '社會工作局' },
  { title: '申請成為寄養父母' },
];


/**
 * 受資助托兒所開放日 列表
 */
export const getWebOpendayListBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '社會工作局' },
  { title: '受資助托兒所開放日申請' },
];

/**
 * 家長講座/工作坊/活動 列表
 */
export const getWebSessionListBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '社會工作局' },
  { title: '家長講座/工作坊/活動' },
];

/**
 * 我的寄養服務申請記錄 列表
 */
export const getWebFosterApplyListBreadcrumbItems = (serviceName?: string) => [
  { title: '首页' },
  { title: '社會工作局' },
  { title: '申請成為寄養父母' },
];
